import styled from "@emotion/styled"
import { ProjectPage } from "utils"
import GoogleMap from "../Map"
import WhiteBgHeading from "./WhiteBgHeading"

const StyledMap = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: 0 auto;
  padding-block: 88px;
`

type Props = {
  projectData: ProjectPage
  locale: string
}

const MapContainer = ({ projectData, locale }: Props) => {
  const mapTitle = projectData?.mapTitle
  return (
    <StyledMap>
      {mapTitle && <WhiteBgHeading title={mapTitle} />}
      <GoogleMap
        address={projectData.address}
        locale={locale}
        mapContainerProps={{
          padding: 0,
          mobileBorderRadius: "0",
          desktopBorderRadius: "12px",
          desktopHeight: "445px",
          mobileHeight: "445px",
        }}
      />
    </StyledMap>
  )
}
export default MapContainer
